import { connect } from 'react-redux';
import { dismissMessage } from 'researcher/application/actions';
import { hideCheckSpamMessageBanner } from 'researcher/user/actions';
import withRouter from 'shared/helper/with-router';
import { getIsOrderFormRoute, getIsDashboardRoute, getSubNavItems, getIsCurieRoute, getIsHomeRoute } from '../reducer';
import CommonLayout from './CommonLayout';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    user = _ref.user;
  var location = _ref2.location;
  return {
    displayOrderFormBanner: getIsOrderFormRoute({
      location: location
    }),
    displayCheckSpamMessagesBanner: user.showCheckSpamMessage,
    displayDashboardBanner: getIsDashboardRoute({
      location: location
    }),
    heading: application.heading,
    isOrderFormProcess: getIsOrderFormRoute({
      location: location
    }),
    isCurieRoute: getIsCurieRoute({
      location: location
    }),
    isHomeRoute: getIsHomeRoute({
      location: location
    }),
    updatingTranslations: application.status.updatingTranslations,
    user: user,
    subnavItems: getSubNavItems({
      application: application,
      user: user,
      location: location
    })
  };
};
var mapDispatchToProps = {
  dismissMessage: dismissMessage,
  hideCheckSpamMessageBanner: hideCheckSpamMessageBanner
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommonLayout));